import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

export const Footer = () => {
  const { isAdmin } = useAuth();
  
  return (
    <footer className="w-full py-6 px-4 mt-auto bg-secondary/30 border-t border-border/50">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-1 text-sm text-muted-foreground">
            <span>©</span>
            <span>{new Date().getFullYear()}</span>
            <span className="font-display">Korsordslexikon.se</span>
          </div>
          
          <nav className="flex items-center gap-4 text-sm">
            <a href="/?tab=forum" className="text-muted-foreground hover:text-foreground transition-colors">
              Forum
            </a>
            <span className="text-border">·</span>
            <a href="/statistik" className="text-muted-foreground hover:text-foreground transition-colors">
              Statistik
            </a>
            <span className="text-border">·</span>
            <a href="/integritetspolicy" className="text-muted-foreground hover:text-foreground transition-colors">
              Integritetspolicy
            </a>
            <span className="text-border">·</span>
            <a
              href="mailto:info@korsordslexikon.se"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Kontakt
            </a>
            {isAdmin && (
              <>
                <span className="text-border">·</span>
                <Link 
                  to="/admin" 
                  className="text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1"
                >
                  <Shield className="h-3 w-3" />
                  Admin
                </Link>
              </>
            )}
          </nav>
        </div>
      </div>
    </footer>
  );
};
